import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M169.3 73.6H37.4c-.8 0-1.4.7-1.3 1.4l12.1 104.8c0 5.6 4.8 10.2 10.7 10.2h88.9c5.9 0 10.7-4.6 10.7-10.2L170.7 75c0-.7-.6-1.4-1.4-1.4zm-93.8 91h-3.9c-2.6 0-4.8-2-4.8-4.5l-4.9-56.2c0-2.5 2.1-4.5 4.8-4.5h3.9c2.6 0 4.8 2 4.8 4.5l4.9 56.2c0 2.4-2.2 4.5-4.8 4.5zm34.6-4.5c0 2.5-2.1 4.5-4.8 4.5h-3.9c-2.6 0-4.8-2-4.8-4.5v-56.2c0-2.5 2.1-4.5 4.8-4.5h3.9c2.6 0 4.8 2 4.8 4.5v56.2zm29.9 0c0 2.5-2.1 4.5-4.8 4.5h-3.9c-2.6 0-4.8-2-4.8-4.5l4.9-56.2c0-2.5 2.1-4.5 4.8-4.5h3.9c2.6 0 4.8 2 4.8 4.5l-4.9 56.2zm32.5-121-142.3 31c-.8.2-1.6-.3-1.8-1.1l-1.8-7.4C25.3 56.1 29 50.4 35 49.1l123.5-26.9c6-1.3 11.9 2.3 13.3 7.9l1.8 7.4c.2.7-.3 1.5-1.1 1.6zM75 34.2c-1.3-5.3 2.2-10.7 7.9-12l19.8-4.4c5.6-1.2 11.3 2.1 12.6 7.5l.8 3.1 8.9-2-.6-2.5c-2.4-9.6-12.6-15.7-22.8-13.4l-21.2 4.7c-10.2 2.2-16.6 12-14.2 21.6l.6 2.5 8.9-2-.7-3.1z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}